import { render, staticRenderFns } from "./DocumentCategoryView.vue?vue&type=template&id=68359326&"
import script from "./DocumentCategoryView.vue?vue&type=script&lang=js&"
export * from "./DocumentCategoryView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports